import * as dictService from "@/api/system/dictbiz";
const viewPortHeight =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;
export const dataOptions = {
  searchMenuSpan: 4,
  height: "auto",
  searchMenuPosition: "left",
  dateBtn: false,
  border: true,
  tip: true,
  searchShow: true,
  addBtn: false,
  refreshBtn: true,
  addRowBtn: false,
  columnBtn: true,
  delBtn: false,
  editBtn: false,
  cancelBtn: true,
  rowKey: "",
  showPage: true,
  index: true,
  selection: false,
  showHeader: true,
  expand: false,
  highlightCurrentRow: true,
  stripe: false,
  emptyBtn: false,
  menuWidth: 240,
  reserveSelection: true,
  column: [
    {
      width: "auto",
      overHidden: true,
      align: "right",
      label: "主键id",
      prop: "id",
      hide: true,
    },
    {
      width: 150,
      overHidden: true,
      label: "所属楼宇",
      prop: "building_id",
      hide: true,
      search: true,
      type: "select",
      dicData: [],
      searchSpan: 6,
    },
    {
      width: 150,
      overHidden: true,
      label: "所属楼宇",
      prop: "building_name",
      hide: false,
      // search: true,
      type: "select",
      dicData: [],
      searchSpan: 6,
    },
    {
      width: "200",
      overHidden: true,
      align: "left",
      label: "企业名称",
      fixed: true,
      prop: "name",
      search: true,
      hide: false,
      slot: true,
      searchSpan: 6,
    },
    {
      width: "150",
      overHidden: true,
      align: "left",
      label: "统一社会信用代码",
      prop: "uniform_social_credit_code",
      search: true,
      hide: false,
      searchSpan: 6,
      searchLabelWidth: 130,
    },
    {
      width: "auto",
      overHidden: true,
      align: "left",
      label: "企业法人",
      prop: "legal_person",
      hide: false,
    },
    {
      width: "100",
      overHidden: true,
      align: "left",
      label: "企业类型",
      prop: "type",
    },
    {
      width: "100",
      overHidden: true,
      align: "left",
      label: "企业规模",
      prop: "firm_size",
    },
    {
      width: "100",
      overHidden: true,
      align: "right",
      label: "注册资金(万)",
      prop: "registered_capital",
    },
    {
      width: "auto",
      overHidden: true,
      align: "left",
      label: "负责人姓名",
      prop: "principal",
      hide: false,
    },
    {
      width: "100",
      overHidden: true,
      align: "left",
      label: "联系电话",
      prop: "phone_num",
      hide: false,
    },
    {
      width: "auto",
      overHidden: true,
      align: "right",
      label: "排序",
      prop: "sort",
      hide: true,
    },
    {
      width: "auto",
      overHidden: true,
      align: "left",
      label: "附件集合id",
      prop: "attachment_id",
      hide: true,
    },

    {
      align: "left",
      searchSpan: 6,
      label: "企业状态",
      prop: "status",
      search: true,
      type: "select",
      dicData: [
        {
          label: "未注册",
          value: 0,
        },
        {
          label: "已注册",
          value: 1,
        },
        {
          label: "注册已过期",
          value: 2,
        },
      ],
    },
    {
      width: "auto",
      overHidden: true,
      align: "left",
      label: "创建时间",
      prop: "create_time",
      hide: true,
      searchSpan: 6,
      search: true,
      type: "date",
      format: "yyyy-MM-dd",
      valueFormat: "yyyy-MM-dd",
      searchRange: true,
      rules: [
        {
          required: true,
          message: "请输入开始时间",
          trigger: "blur",
        },
      ],
    },
  ],
};
